//刷新页面后重新从localStrong中获取用户登录信息
const userInfo = JSON.parse(window.localStorage.getItem('userLoginMessage')) || {};
//用户数据
export default {
  userLoginMessage: userInfo,              //用户登录后返回的数据
  userHeadInfo:{},                         //用户基本信息：头像、未读消息，会员等级等信息
  unReadTrade:0,                           //未读交易提醒
  unReadSys:0,                             //未读系统公告
  msgLists: {                              //用户消息列表
    total:0,
    lists:[]
  },
  msgDetail:{},                            //消息详情
  accessLists:[],                          //用户的所有权限节点
  positionLists:{                          //门店职位信息列表
      total:0,
      lists:[]
  },
  salesAssociationLists:{                  //销售关联酒店列表
      total:0,
      lists:[]
  },
  positionDetail:{},                       //某一职位的信息详情
  staffLists:{                             //门店员工信息列表
    total:0,
    lists:[]
  },
  accountStructure:[],                     //账号之间的架构关系
  staffDetail:{},                          //员工（子）账号的信息详情
  IndexData:{
    pending_order_arr:{},
    edit_verify_arr:{},
    list:[],
    money_arr:{
      freeze_money:0,
      money:0
    },
    send_order_arr:{
      
    },
    order_arr:{
      doing_count:0,
      end_count:0,
      in_count:0,
      wait_in_count:0,
      wait_offer_count:0
    },
    position_arr:{
      position_count:0,
      user_count:0
    },
    pending_order_arr:{},
    room_meeting_arr:{
      meeting_count:0,
      room_count:0
    },
    reg_verify_arr:{}
  },                            //用户中心展示的数据集
}
